import type { FaireProductEntity } from "../../entity_types/product";

export const p_bfwpbr5c9y: FaireProductEntity = {
  token: "p_bfwpbr5c9y",
  type: "product",
  name: "Blossoms Yoga Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/3916d961f7f7f45bcbf0b2e05cd24afc6d96c3390b1411d5abe3a5de35f2a1e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20f6527e01afb4661398103254dc0b5811ce3062b32c45ebe75fafc4b9dfc4b5.jpeg",
    "https://cdn.faire.com/fastly/a1660b74bd2c740d06476e28c467c70def35f431a2094fd70ae46492cc9f2607.jpeg",
    "https://cdn.faire.com/fastly/ca74122d44c56447b5da18b6a343687a89bb9c673c01be34f2a42196b791b968.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\nPractice makes perfect. \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n...\n\n\n\n * ♺ Made from post-consumer recycled materials \n * 27”x72” \n * Ultra absorbent and fast-drying \n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop\n\n * Machine washable \n...\n\n\nStretch responsibly.\n\n\nOur Yoga Towel keeps up with your practice, but it also keeps the environment in mind, too. Our towels are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And due to its innovative weave, high absorbency and quick dry time, you’ll wash your towels less often, helping to minimize yours. \n\n\n",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:59.846Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
